import { __assign } from "tslib";
export var defaultStateValues = {
    status: 'inactive',
    lastDirection: 'unset',
    currentStepIndex: -1,
    displayIndex: -1,
    hasNavigated: false,
    currentCalloutLoaded: false,
};
export var teachingUiComponentStateReducer = function (current, action) {
    if (current.status === 'complete') {
        return current;
    }
    if (current.status === 'inactive') {
        if (action.type === 'init') {
            return {
                status: 'active',
                lastDirection: 'unset',
                currentStepIndex: action.startingIndex,
                displayIndex: action.startingIndex + 1,
                hasNavigated: false,
                currentCalloutLoaded: false,
            };
        }
    }
    if (current.status === 'active') {
        if (action.type === 'next' || action.type === 'previous') {
            var modifier = action.type === 'previous' ? -1 : 1;
            // Clamp the values just in case they get out of sync for some reason
            var currentStepIndex = Math.max(current.currentStepIndex + modifier, 0);
            var displayIndex = Math.max(current.displayIndex + modifier, 1);
            return __assign(__assign({}, defaultStateValues), { status: 'active', lastDirection: action.type, currentStepIndex: currentStepIndex, displayIndex: displayIndex });
        }
        if (action.type === 'skip') {
            var modifier = current.lastDirection === 'previous' ? -1 : 1;
            return __assign(__assign({}, current), { currentStepIndex: current.currentStepIndex + modifier });
        }
        if (action.type === 'complete') {
            return __assign(__assign({}, defaultStateValues), { status: 'complete' });
        }
        if (action.type === 'setLoaded') {
            return __assign(__assign({}, current), { currentCalloutLoaded: true });
        }
        if (action.type === 'setNavigation') {
            return __assign(__assign({}, current), { currentCalloutLoaded: true });
        }
    }
    return current;
};
//# sourceMappingURL=teachingUiComponentStateReducer.js.map